<div class="fake-check" [class.active]="model">
    <span></span>
</div>
